import { THEME } from '@lyon/utils/theme';
import { RadioGroupOverrides, RadioOverrides } from 'baseui/radio';

export const RADIO_GROUP: RadioGroupOverrides = {
  RadioGroupRoot: {
    style: {
      marginTop: '32px',
      marginBottom: 0,
      width: '50%',
    },
  },
};

export const RADIO: RadioOverrides = {
  Root: {
    style: ({ $checked }) => ({
      width: 'calc(100% - 16px)',
      display: 'grid',
      gridTemplateColumns: 'auto 1fr',
      alignItems: 'center',
      paddingTop: '4px',
      paddingBottom: '4px',
      paddingLeft: '16px',
      backgroundColor: $checked
        ? THEME.colors.darkmuted500
        : 'auto',
    }),
  },
  Label: {
    style: {
      display: 'grid',
      gridTemplateColumns: '1fr auto',
      gridColumnGap: '16px',
      alignItems: 'center',
    },
  },
  Input: {
    style: {
      display: 'none',
    },
  },
};
